/* Maison RHB: full-screen touch zoom for phones and tablets.
   Tap a product image -> full-screen viewer. Pinch or double-tap to zoom, drag to pan,
   swipe left/right to change image. Mouse users keep the hover magnifier. */
(function () {
  var BOX = '.product__media-wrapper [x-data="ImageZoom"]';
  var lastPointer = "mouse";
  var lastPointerTime = 0;

  document.addEventListener(
    "pointerdown",
    function (e) {
      lastPointer = e.pointerType;
      lastPointerTime = Date.now();
    },
    true
  );

  function isTouchTap() {
    if (lastPointer === "touch" || lastPointer === "pen") return Date.now() - lastPointerTime < 1500;
    return false;
  }

  function hiRes(src) {
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set("width", "3000");
      return u.toString();
    } catch (err) {
      return src;
    }
  }

  function boxImage(box) {
    var imgs = Array.prototype.slice.call(box.querySelectorAll("img"));
    var main = imgs.filter(function (i) { return !i.classList.contains("transition-image"); })[0];
    var img = main || imgs[0];
    if (!img) return null;
    if (img.complete && !img.naturalWidth) return null;
    if (!/\.(jpe?g|png|webp|gif|avif)(\?|$)/i.test(img.currentSrc || img.src)) return null;
    return { src: hiRes(img.currentSrc || img.src), low: img.currentSrc || img.src, alt: img.alt || "" };
  }

  function collect(clickedBox) {
    var wrapper = clickedBox.closest(".product__media-wrapper");
    var boxes = Array.prototype.slice.call(wrapper.querySelectorAll('[x-data="ImageZoom"]'));
    var list = [];
    var start = 0;
    var seen = {};
    boxes.forEach(function (b) {
      var d = boxImage(b);
      if (!d) return;
      var key = d.low.split("?")[0].replace(/^https?:/, "");
      if (key in seen) {
        if (b === clickedBox) start = seen[key];
        return;
      }
      seen[key] = list.length;
      if (b === clickedBox) start = list.length;
      list.push(d);
    });
    return { list: list, start: start };
  }

  var css =
    ".mrz{position:fixed;inset:0;z-index:2147483000;background:#fff;touch-action:none;user-select:none;-webkit-user-select:none;overflow:hidden;opacity:0;transition:opacity .2s ease}" +
    ".mrz.on{opacity:1}" +
    ".mrz-track{position:absolute;inset:0;display:flex;will-change:transform}" +
    ".mrz-slide{flex:0 0 100%;width:100%;height:100%;position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center}" +
    ".mrz-slide img{max-width:100%;max-height:100%;object-fit:contain;transform-origin:0 0;will-change:transform;pointer-events:none;-webkit-user-drag:none}" +
    ".mrz-close{position:absolute;top:max(14px,env(safe-area-inset-top));right:14px;width:44px;height:44px;border-radius:50%;border:0;background:rgba(0,0,0,.72);color:#fff;font-size:26px;line-height:44px;text-align:center;z-index:3;padding:0;cursor:pointer}" +
    ".mrz-count{position:absolute;top:max(24px,calc(env(safe-area-inset-top) + 10px));left:18px;font:500 14px/1 system-ui,-apple-system,sans-serif;color:#111;letter-spacing:.04em;z-index:3}" +
    ".mrz-hint{position:absolute;left:50%;bottom:max(28px,calc(env(safe-area-inset-bottom) + 18px));transform:translateX(-50%);background:rgba(0,0,0,.72);color:#fff;font:500 13px/1 system-ui,-apple-system,sans-serif;padding:10px 16px;border-radius:999px;white-space:nowrap;z-index:3;transition:opacity .4s ease}";

  function injectCss() {
    if (document.getElementById("mrz-css")) return;
    var s = document.createElement("style");
    s.id = "mrz-css";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function open(list, start) {
    injectCss();
    var root = document.createElement("div");
    root.className = "mrz";
    root.setAttribute("role", "dialog");
    root.setAttribute("aria-modal", "true");
    root.setAttribute("aria-label", "Image zoom");
    var track = document.createElement("div");
    track.className = "mrz-track";
    var slides = list.map(function (d) {
      var s = document.createElement("div");
      s.className = "mrz-slide";
      var im = document.createElement("img");
      im.alt = d.alt;
      im.decoding = "async";
      im.src = d.low;
      var hi = new Image();
      hi.onload = function () { im.src = d.src; };
      s._hi = hi;
      s._hiSrc = d.src;
      s.appendChild(im);
      track.appendChild(s);
      return { el: s, img: im, scale: 1, x: 0, y: 0 };
    });
    var close = document.createElement("button");
    close.className = "mrz-close";
    close.type = "button";
    close.setAttribute("aria-label", "Close");
    close.innerHTML = "&times;";
    var count = document.createElement("div");
    count.className = "mrz-count";
    var hint = document.createElement("div");
    hint.className = "mrz-hint";
    hint.textContent = "Pinch or double-tap to zoom";
    root.appendChild(track);
    root.appendChild(count);
    root.appendChild(close);
    root.appendChild(hint);
    document.body.appendChild(root);

    var prevOverflow = document.documentElement.style.overflow;
    var prevBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    var index = start;
    var W = root.clientWidth;
    function loadHi(i) {
      var s = slides[i];
      if (s && !s.el._hi.src) s.el._hi.src = s.el._hiSrc;
    }
    function setTrack(dx, animate) {
      track.style.transition = animate ? "transform .28s ease" : "none";
      track.style.transform = "translate3d(" + (-index * W + dx) + "px,0,0)";
    }
    function updateCount() {
      count.textContent = index + 1 + " / " + slides.length;
      loadHi(index);
      loadHi(index + 1);
      loadHi(index - 1);
    }
    function apply(s, animate) {
      s.img.style.transition = animate ? "transform .25s ease" : "none";
      s.img.style.transform = "translate3d(" + s.x + "px," + s.y + "px,0) scale(" + s.scale + ")";
    }
    function baseRect(s) {
      // image rect at scale 1 (layout box, unaffected by transform)
      return { left: s.img.offsetLeft, top: s.img.offsetTop, w: s.img.offsetWidth, h: s.img.offsetHeight };
    }
    function clamp(s) {
      var r = baseRect(s);
      var sw = r.w * s.scale, sh = r.h * s.scale;
      var vw = s.el.clientWidth, vh = s.el.clientHeight;
      // position of the image's top-left in the slide = r.left + x
      var minX, maxX, minY, maxY;
      if (sw <= vw) { minX = maxX = (vw - sw) / 2 - r.left; } else { minX = vw - sw - r.left; maxX = -r.left; }
      if (sh <= vh) { minY = maxY = (vh - sh) / 2 - r.top; } else { minY = vh - sh - r.top; maxY = -r.top; }
      s.x = Math.min(maxX, Math.max(minX, s.x));
      s.y = Math.min(maxY, Math.max(minY, s.y));
    }
    function zoomAt(s, newScale, cx, cy, animate) {
      // cx, cy in slide coordinates
      newScale = Math.min(5, Math.max(1, newScale));
      var r = baseRect(s);
      var px = (cx - r.left - s.x) / s.scale;
      var py = (cy - r.top - s.y) / s.scale;
      s.scale = newScale;
      s.x = cx - r.left - px * newScale;
      s.y = cy - r.top - py * newScale;
      if (newScale === 1) { s.x = 0; s.y = 0; }
      clamp(s);
      apply(s, animate);
    }
    function reset(s) { s.scale = 1; s.x = 0; s.y = 0; apply(s, false); }

    setTrack(0, false);
    updateCount();
    requestAnimationFrame(function () { root.classList.add("on"); });
    setTimeout(function () { hint.style.opacity = "0"; }, 2600);

    var pointers = {};
    var gesture = null;
    var lastTap = 0, lastTapX = 0, lastTapY = 0;

    function slidePoint(e) {
      var b = slides[index].el.getBoundingClientRect();
      return { x: e.clientX - b.left, y: e.clientY - b.top };
    }
    function pts() { return Object.keys(pointers).map(function (k) { return pointers[k]; }); }

    function onDown(e) {
      if (e.target === close) return;
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var s = slides[index];
      var p = pts();
      if (p.length === 2) {
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        var b = s.el.getBoundingClientRect();
        gesture = { type: "pinch", d0: d, s0: s.scale, x0: s.x, y0: s.y,
          cx: (p[0].x + p[1].x) / 2 - b.left, cy: (p[0].y + p[1].y) / 2 - b.top };
        setTrack(0, true);
      } else if (p.length === 1) {
        gesture = { type: s.scale > 1.01 ? "pan" : "swipe", sx: e.clientX, sy: e.clientY, x0: s.x, y0: s.y, t: Date.now(), moved: false };
      }
    }
    function onMove(e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (!gesture) return;
      var s = slides[index];
      if (gesture.type === "pinch") {
        var p = pts();
        if (p.length < 2) return;
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        var b = s.el.getBoundingClientRect();
        var cx = (p[0].x + p[1].x) / 2 - b.left, cy = (p[0].y + p[1].y) / 2 - b.top;
        var ns = Math.min(5, Math.max(1, gesture.s0 * d / gesture.d0));
        var r = baseRect(s);
        var px = (gesture.cx - r.left - gesture.x0) / gesture.s0;
        var py = (gesture.cy - r.top - gesture.y0) / gesture.s0;
        s.scale = ns;
        s.x = cx - r.left - px * ns;
        s.y = cy - r.top - py * ns;
        clamp(s);
        apply(s, false);
        return;
      }
      var dx = e.clientX - gesture.sx, dy = e.clientY - gesture.sy;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) gesture.moved = true;
      if (gesture.type === "pan") {
        s.x = gesture.x0 + dx;
        s.y = gesture.y0 + dy;
        clamp(s);
        apply(s, false);
      } else if (gesture.type === "swipe") {
        var edge = (index === 0 && dx > 0) || (index === slides.length - 1 && dx < 0);
        setTrack(edge ? dx * 0.3 : dx, false);
      }
    }
    function onUp(e) {
      if (!pointers[e.pointerId]) return;
      delete pointers[e.pointerId];
      var s = slides[index];
      var remaining = pts();
      if (gesture && gesture.type === "pinch") {
        if (s.scale < 1.05) { reset(s); apply(s, true); }
        if (remaining.length === 1) {
          gesture = { type: s.scale > 1.01 ? "pan" : "swipe", sx: remaining[0].x, sy: remaining[0].y, x0: s.x, y0: s.y, t: Date.now(), moved: true };
        } else gesture = null;
        return;
      }
      if (!gesture) return;
      var dx = e.clientX - gesture.sx;
      if (gesture.type === "swipe" && gesture.moved) {
        var fast = Date.now() - gesture.t < 300 && Math.abs(dx) > 30;
        if ((dx < -W * 0.2 || (fast && dx < 0)) && index < slides.length - 1) { reset(slides[index]); index++; }
        else if ((dx > W * 0.2 || (fast && dx > 0)) && index > 0) { reset(slides[index]); index--; }
        setTrack(0, true);
        updateCount();
      } else if (gesture.type === "swipe") {
        setTrack(0, true);
      }
      if (!gesture.moved) {
        var now = Date.now();
        var pt = slidePoint(e);
        if (now - lastTap < 320 && Math.abs(pt.x - lastTapX) < 40 && Math.abs(pt.y - lastTapY) < 40) {
          if (s.scale > 1.01) { s.scale = 1; s.x = 0; s.y = 0; clamp(s); apply(s, true); }
          else zoomAt(s, 2.5, pt.x, pt.y, true);
          lastTap = 0;
        } else {
          lastTap = now; lastTapX = pt.x; lastTapY = pt.y;
        }
      }
      gesture = null;
    }
    root.addEventListener("pointerdown", onDown);
    root.addEventListener("pointermove", onMove);
    root.addEventListener("pointerup", onUp);
    root.addEventListener("pointercancel", onUp);
    root.addEventListener("gesturestart", function (e) { e.preventDefault(); });
    root.addEventListener("dblclick", function (e) { e.preventDefault(); });

    function onResize() { W = root.clientWidth; slides.forEach(reset); setTrack(0, false); }
    window.addEventListener("resize", onResize);
    function onKey(e) {
      if (e.key === "Escape") shut();
      if (e.key === "ArrowRight" && index < slides.length - 1) { reset(slides[index]); index++; setTrack(0, true); updateCount(); }
      if (e.key === "ArrowLeft" && index > 0) { reset(slides[index]); index--; setTrack(0, true); updateCount(); }
    }
    document.addEventListener("keydown", onKey);

    function shut() {
      window.removeEventListener("resize", onResize);
      document.removeEventListener("keydown", onKey);
      document.documentElement.style.overflow = prevOverflow;
      document.body.style.overflow = prevBodyOverflow;
      root.classList.remove("on");
      setTimeout(function () { root.remove(); }, 220);
    }
    close.addEventListener("click", function (e) { e.stopPropagation(); shut(); });
    close.addEventListener("pointerdown", function (e) { e.stopPropagation(); });
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!isTouchTap()) return;
      var box = e.target.closest && e.target.closest(BOX);
      if (!box) return;
      var c = collect(box);
      if (!c.list.length) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      open(c.list, c.start);
    },
    true
  );
})();
